var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateTemplate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3333 8.08333V5C14.3333 3.59987 14.3333 2.8998 14.0608 2.36503C13.8212 1.89462 13.4388 1.51217 12.9683 1.27248C12.4335 1 11.7335 1 10.3333 1H5C3.59987 1 2.8998 1 2.36503 1.27248C1.89462 1.51217 1.51217 1.89462 1.27248 2.36503C1 2.8998 1 3.59987 1 5V13.6667C1 15.0668 1 15.7668 1.27248 16.3017C1.51217 16.7721 1.89462 17.1545 2.36503 17.3942C2.8998 17.6667 3.59987 17.6667 5 17.6667H7.66667M9.33333 8.5H4.33333M6 11.8333H4.33333M11 5.16667H4.33333M12.6667 16.8333V11.8333M10.1667 14.3333H15.1667",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateTemplate);
export default __webpack_public_path__ + "static/media/create_template.17d8c2158358f06719abbdab4c40812c.svg";
export { ForwardRef as ReactComponent };